import AsyncSelect from "react-select/async";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
//import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { appointmentType } from '../../redux/actions/appointmentActions'
import AppointmentStep3 from "./Step3";
import PatientInfo from "./PatientInfo";

function AppointmentStep2() {

  let AccessToken = localStorage.getItem("AccessToken");
  let NodeServerHost = process.env.REACT_APP_API_URL;
  let CareCode = localStorage.getItem("CareCode");
  let OperatingId = process.env.REACT_APP_OperatingId;
  let orgId = localStorage.getItem("orgId");

  const [selectedValue, setSelectedValue] = useState(null);
  const [asyncSelect, setAsyncSelect] = useState([{ value: null }]);

  const healthcareService = [...asyncSelect];
  const toggleClass = () => {
    healthcareService.push({ value: null });
    setAsyncSelect(healthcareService);
  };

  // handle selection
  const handleLocationChange = (value) => {
    setSelectedValue(value);
  };

  // load options using API call
  const loadLocationOptions = async (inputValue) => {
    return await fetch(NodeServerHost + `/Location/List?name=${inputValue}`, {
      headers: {
        OrganizationId: orgId,
        CareCode: CareCode,
        OperatingId: OperatingId,
        //Authorization: "Bearer " + AccessToken,
        "Content-Type": "application/json",
      },
    }).then((res) =>
      //console.log(res.json())
      res.json()
    );
  };

  const handleHealthcareServiceChange = (value, index) => {
    const tempAsyncSelect = [...asyncSelect];
    const temp = tempAsyncSelect.map((select, index1) => {
      if (index === index1) {
        select.value = value;
      }
      return select;
    });
    //console.log(`index: ${index} value: ${value} arr: ${temp}`);
    setAsyncSelect(temp);
  };

  const loadLHealthcareServiceOptions = async (inputValue) => {
    return await fetch(
      NodeServerHost + `/HealthcareService/List?name=${inputValue}`,
      {
        headers: {
          OrganizationId: orgId,
          CareCode: CareCode,
          OperatingId: OperatingId,
          //Authorization: "Bearer " + AccessToken,
          "Content-Type": "application/json",
        },
      }
    ).then((res) => res.json());
  };

  const { register, handleSubmit, formState: { errors } } = useForm();

  //const navigate = useNavigate();

  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.appointmentType.step2)

  const [showStepThree, setShowStepThree] = useState(false);

  const onSubmit = (data) => {
    //navigate("/Appointment/Step3")
    //console.log(locationAsyncSelect);
    setShowStepThree(value => !value);
    dispatch(appointmentType({location: selectedValue, healthcareService}))
  };

  if(showStepThree !== true){
    return (
      <div className="row justify-content-md-center">
        <div className="appointmentBackground"></div>
        <div className="col col-lg-4">
          <h3 className="mt-5 mb-3">Book an Appointment</h3>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card pb-3 p-3 boxviewtransperant">
              <div className="card-body">
                <PatientInfo></PatientInfo>
                <div className="form-group">
                  <label className="fw-bold form-label">
                    <span className="text-danger">*</span> Location
                  </label>
                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    value={selectedValue}
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.id}
                    loadOptions={loadLocationOptions}
                    onChange={handleLocationChange}
                    placeholder="Select locations"
                    name="appointmentLocation"
                    isMulti
                  />
                  {errors.appointmentLocation && (
                    <span className="text-danger">
                      This field is required
                    </span>
                  )}
                </div>
                <div className="HealthcareServices">
                  <div className="form-group">
                    <label className="fw-bold form-label">Healthcare Service</label>
                    {asyncSelect.map((select, index) => {
                      return (
                        <div>
                        <AsyncSelect className="mb-3"
                          cacheOptions
                          defaultOptions
                          value={select.value}
                          getOptionLabel={(e) => e.name}
                          getOptionValue={(e) => e.id}
                          loadOptions={loadLHealthcareServiceOptions}
                          name="appointmentService"
                          onChange={(value) =>
                            handleHealthcareServiceChange(value, index)
                          }
                          placeholder="Select service"
                        />
                        {/* <AsyncSelect className="mb-3"
                          cacheOptions
                          defaultOptions
                          value={select.value}
                          getOptionLabel={(e) => e.name}
                          getOptionValue={(e) => e.id}
                          loadOptions={loadLHealthcareServiceOptions}
                          name="appointmentService"
                          onChange={(value) =>
                            handleHealthcareServiceChange(value, index)
                          }
                          placeholder="Select practitioner"
                        /> */}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <a
                  href="javacript:void(0)"
                  onClick={toggleClass}
                >
                  + Add Appointment
                </a>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <button
                      className="btn btn-secondary btn-block"
                      style={{ width: "100%" }}
                    >
                      I have Insurance
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      className="btn btn-secondary btn-block"
                      style={{ width: "100%" }}
                    >
                      I don't have Insurance
                    </button>
                  </div>
                </div>
                <h5 className="mt-4 mb-3">
                  To schedule your appointment you will need...
                </h5>
                <ul>
                  <li>Your Insurance Card</li>
                  <li>Prescription / Order</li>
                  <li>Name of your referring physician</li>
                  <li>A contact email address or cell phone number</li>
                </ul>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <button
                  className="btn btn-secondary btn-block"
                  style={{ width: "100%" }}
                >
                  Continue
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }else{
    return(
      <AppointmentStep3 />
    )
  }
 
}

export default AppointmentStep2;
